<template>
  <div class="ai-generate-tone-selector d-flex align-items-center justify-content-between flex-wrap gap-gd-1">
    <!-- Tone Selector (using ChipSelect dropdown mode) -->
    <div class="d-flex align-items-center gap-gd-half">
      <b-skeleton-wrapper :loading="isLoadingAPI" :row="1" :col="1">
        <template #loading>
          <b-skeleton type="button" height="32px" width="100px" class="border-radius-rounder"></b-skeleton>
        </template>
        <template #default>
        <ChipSelect
          v-if="availableTones && availableTones.length > 0"
          mode="dropdown"
          :options="availableTones"
          :value="selectedTone"
          :label="$t('engine.aiGenerate.lblTone', languageEngine)"
          :disabled="isLoading"
          isLabelAndValue
          option-value="id"
          option-label="name"
          @change="selectTone"
          />
        </template>
      </b-skeleton-wrapper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ChipSelect from '@components_system/Shared/Tools/ChipSelect/ChipSelect.vue';

export default {
  name: 'AIGenerateToneSelector',
  components: {
    ChipSelect,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedTone: null,
    };
  },
  created() {
    if(this.prompt.tone === undefined || this.prompt.tone.length === 0) {
      this.$store.dispatch('designIframe/ai/fetchPrompt', { type: 'text', subType: 'tone' });
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: 'designIframe/userPreference/languageEngine',
      prompt: 'designIframe/ai/prompt',
      loading: 'designIframe/ai/loading',
    }),
    availableTones() {
      return this.prompt.tone || [];
    },
    isLoadingAPI(){
      return this.loading && this.loading.tone || false;
    }
  },
  methods: {
    selectTone(tone) {
      this.selectedTone = tone.id;
      this.$emit('tone-selected', tone);
    },
  }
};
</script>